import { ListingViewSection } from 'modules/listing/components/ListingView/Section/ListingViewSection';
import { ListingRichTextTruncatedHtmlWithLinks } from 'modules/listing/components/RichText/ListingRichTextTruncatedHtmlWithLinks';

type Props = {
  benefits: string | null;
  benefitsTruncated: string | null;
  onToggleDetails?: (isOpen: boolean) => void;
};

export function ListingViewBenefitsSection({
  benefits,
  benefitsTruncated,
  onToggleDetails,
}: Props) {
  if (!benefits || !benefitsTruncated) return null;

  return (
    <ListingViewSection
      title={
        /* TRANSLATORS: Listing Page, section title */
        getText('Benefits')
      }
    >
      <ListingRichTextTruncatedHtmlWithLinks
        showMoreLinkTitle={getText('Read more about benefits')}
        showLessLinkTitle={getText('Read less about benefits')}
        html={benefits}
        truncatedHtml={benefitsTruncated}
        onToggle={onToggleDetails}
        toggleQAId="show-listing-benefits-toggle"
      />
    </ListingViewSection>
  );
}
